module.exports = __webpack_public_path__ + "static/media/helvetica-neue-light.c9f55d4c.woff2";